import React from 'react'
import moment from 'moment'
import { formatHoursMinutes, formatNumber } from 'core/lib'

function Reservation({ product }) {
	return <p className='product'>
		<span className='name'>{product.name}</span>
		<span className="amount">{formatNumber(product.price)} €</span>
		<br/>
		<small>{moment(product.reservation_day).format('DD/MM/YYYY')} | {formatHoursMinutes(product.start)} - {formatHoursMinutes(product.end)}</small>
	</p>
}

export default Reservation
